import type React from 'react'
import useMediaQuery from '@/hooks/useMediaQuery.ts'
import config from 'tailwind.config'

import { Section } from '@/components/Sections/Section'
import { MediaQuery } from '@/components/MediaQuery'
import { FullBleedVariant } from './FullBleedVariant.tsx'
import { InsetVariant } from './InsetVariant.tsx'
import { LegacyVariant } from './LegacyVariant.tsx'

import type { CMSSectionFullBleedHeroBanner } from '@/types/sanity'

type SectionFullBleedHeroBanner = {
  content: CMSSectionFullBleedHeroBanner
}

export const FullBleedHeroBanner: React.FC<SectionFullBleedHeroBanner> = ({
  content,
}) => {
  const { _id, mobileConfig, desktopConfig } = content
  const isDesktopScreen = useMediaQuery(
    `(min-width: ${config.theme.screens.lg})`,
    true,
  )
  const theme = isDesktopScreen ? desktopConfig?.theme : mobileConfig?.theme

  return (
    <Section id={_id} theme={theme} hasWrapper={false} size="zero">
      {/* Desktop */}
      <MediaQuery query="(min-width: 1024px)" clientOnly>
        {desktopConfig?.bannerType === 'fullBleed' && (
          <FullBleedVariant config={desktopConfig} />
        )}
        {desktopConfig?.bannerType === 'inset' && (
          <InsetVariant config={desktopConfig} />
        )}
      </MediaQuery>

      {/* Mobile */}
      <MediaQuery query="(max-width: 1023px)" clientOnly>
        {mobileConfig?.bannerType === 'fullBleed' && (
          <FullBleedVariant config={mobileConfig} />
        )}
        {mobileConfig?.bannerType === 'inset' && (
          <InsetVariant config={mobileConfig} />
        )}
        {mobileConfig?.bannerType === 'legacy' && (
          <LegacyVariant config={mobileConfig} />
        )}
      </MediaQuery>
    </Section>
  )
}
